import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";

function MuiIconButton({ icon, title, disabled, ...props }) {
  return (
    <>
      {disabled ? (
        <IconButton disabled={disabled} {...props}>
          {icon}
        </IconButton>
      ) : (
        <Tooltip title={title ? title : ""}>
          <IconButton disabled={disabled} {...props}>
            {icon}
          </IconButton>
        </Tooltip>
      )}
    </>
  );
}

export default MuiIconButton;
